import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import styled from "styled-components";
import { EditorSingleCharacter } from "../character/EditorSingleCharacter";
import { AnimationType } from "../../../shared/resources/AnimationAssetModel";
import { useTranslation } from "react-i18next";
import { AutoScaleContainer } from "./AutoScaleContainer";
import { gameStore } from "../../stores/GameStore";
import { sharedStore } from "../../stores/SharedStore";
import { createRandomBodyTypeCharacter } from "../../helper/characterHelpers";
import { errorStore } from "../../stores/ErrorStore";
const Container = styled.div.withConfig({
  displayName: "PlayerCharacterEditor__Container",
  componentId: "sc-133y411-0"
})(["display:flex;flex-direction:row;height:100%;width:100%;border:black 1px solid;gap:10px;font-size:xx-large;background-color:black;color:white;"]);
export const PlayerCharacterEditor = observer(() => {
  const {
    t
  } = useTranslation();
  const charAnimations = sharedStore.getAnimationsByType(AnimationType.BodyType);

  function onFinish() {
    gameStore.setPlayerCharacter(gameStore.characterEditorStore.selectedCharacterConfiguration);
  }

  useEffect(() => {
    if (!gameStore.characterEditorStore.selectedCharacterConfiguration) {
      createRandomBodyTypeCharacter().then(gameStore.characterEditorStore.setSelectedCharacter).catch(errorStore.addErrorFromErrorObject);
    }
  }, []);
  if (!gameStore.characterEditorStore.selectedCharacterConfiguration) return null;
  return /*#__PURE__*/React.createElement(AutoScaleContainer, {
    width: 1360,
    height: 820
  }, /*#__PURE__*/React.createElement(Container, null, charAnimations.length > 0 && /*#__PURE__*/React.createElement(EditorSingleCharacter, {
    store: gameStore.characterEditorStore,
    onFinish: onFinish,
    finishButtonTranslationKey: "game.character_config_finished",
    checkUniqueName: false,
    isGame: true
  }), charAnimations.length == 0 && /*#__PURE__*/React.createElement(React.Fragment, null, t("game.character_config_error_no_animations"))));
});